import { IonIcon } from '@ionic/react'
import styled from 'styled-components'
import { IonInput } from '~/shared/ui/form/styled'

export const DrawerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled('div')`
  font-size: 18px;
  line-height: 18px;
  font-weight: 500;
  margin-bottom: 16px;
`

export const SearchTitle = styled('div')`
  font-size: 16px;
  line-height: 15px;
  font-weight: 500;
`

export const InputWrapper = styled('div')`
  position: relative;
`

export const InputIcon = styled(IonIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
`

export const VisibleInput = styled(IonInput)`
  && {
    label {
      pointer-events: none;
    }
    input {
      margin-right: 26px !important;
    }
  }
`

export const SearchInput = styled(IonInput)``
